const e=/^#\w{3}$/,t=/^#(\w)(\w)(\w)$/;function n(n){if(n&&typeof n==`string`)return n.match(e)?n.replace(t,`#$1$1$2$2$3$3`):n}export{n as toSafeColor};
//# sourceMappingURL=to-safe-color.js.map